import React, { useCallback } from 'react';
import ImageGallery from 'react-image-gallery';
import { AutoFontSize } from 'auto-fontsize';
import classNames from 'classnames';

import checkmarkImgSrc from '../img/bock.png';
import { isImageMimeType } from '../utils';

export default function QuizAdminQuestion(props) {

  const { 
    color, 
    question,
    questionNumber,
    quizInfo,
    showAnswers = true,
    showMedia = true } = props;
    
  // ========================================================
  // Returns styling information for a question and answer
  // ========================================================
  const getAnswerDisplayConf = useCallback((question, answer) => {

    const classes = { };
    const inlineStyle = { 
      backgroundColor: color.primaryCss 
    };

    const correct = 
      quizInfo.correctAnswerList && 
      quizInfo.correctAnswerList.find(a => a && a.id === answer.id);

    if (correct)
    {
      classes.correctAnswer = true;
    }

    return { inlineStyle, classes, correct };

  }, [ color, quizInfo ]);

  // =======================
  // Extract all image URLs
  // =======================
  let allImageUrls = []
  if (question.mediaList && question.mediaList.length > 0)
  {
    allImageUrls = allImageUrls.concat(
      question.mediaList
        .filter(m => isImageMimeType(m.mimeType))
        .map(m => `/api/quiz/questionMedia/${m.id}`));
  }

  let style = { backgroundColor: color.primaryCss };
  if (props.style) {
    style = Object.assign({}, style, props.style);
  }

  return (
    <div className={classNames("quizQuestion")} style={style}>
      <div className={classNames("quizQuestionNumber")} style={{ color: color.primaryCss }}>
        {questionNumber}
      </div>
      <h3 className="quizQuestionText">{question.markdown}</h3>
      {allImageUrls.length > 0 && showMedia ?
        <div>
          <ImageGallery 
            slideDuration={250}
            disableSwipe={true}
            showPlayButton={false} 
            showFullscreenButton={false}
            items={allImageUrls.map(url => ({ original: url, originalHeight: "400px" }))} />
        </div>
        : null
      }
      {showAnswers && question.config && question.config.inputMode && question.config.acceptedAnswers && question.config.acceptedAnswers.length > 0 &&
        <div className="quizAdminAcceptedAnswers mt-1 mb-1">
          <span className="quizAdminAcceptedAnswersLabel">Rätt svar: </span>
          {question.config.acceptedAnswers.map((a, i) => (
            <span key={i} className="quizAdminAcceptedAnswer">{a}</span>
          ))}
        </div>
      }
      {showAnswers && !(question.config && question.config.inputMode) &&
        <div className="quizAnswerWrapper">
          {question.answerList.map(answer =>
            {
              const answerDisplayConf = getAnswerDisplayConf(question, answer);
              return <div
                key={answer.id}
                style={answerDisplayConf.inlineStyle}
                className={classNames("quizAnswer", answerDisplayConf.classes)}
              >
                <div>
                  <AutoFontSize
                      text={answer.text}
                      minTextSize={10}
                      textSize={15}
                      textSizeStep={2}
                      targetLines={2}
                  />
                </div>
                {quizInfo.completed && answerDisplayConf.correct && <img src={checkmarkImgSrc} alt="" />}
              </div>
            }
          )}
        </div>
      }
    </div>
  );
}